<script>
    import { fly } from "svelte/transition";
    import BarcodeScannerModal from "../../components/BarcodeScannerModal.svelte";
    export let isSidePanelOpen; // bindable
    export let masterInfo; // bindable
    export let lotDetails;
    export let openLotPopup;

    export let shipmntTyList = [];
    export let hbrdSeList = [];
    export let shipmntRegistSeList = [];
    export let vatTyList = [];
    export let crncyList = [];
    export let shipmntSttusList = [];
    export let details = []; // 상세 내역 리스트 추가
    export let onSaveSuccess = () => {}; // 저장 성공 콜백 추가

    import toast from "svelte-french-toast";
    import * as api from "../../utiles/api.js";
    import { Preferences } from "@capacitor/preferences";
    import { onMount } from "svelte";

    let session_bplc_code = "";

    onMount(async () => {
        const { value } = await Preferences.get({ key: "retechInfo" });
        if (value) {
            const userData = JSON.parse(value);
            session_bplc_code = userData.bplc_code || "01";
        }
    });

    let selectedItem = null; // 💡 선택된 상단 품목 정보 객체
    let selectedLotKeys = new Set(); // 💡 고유 키 기반 LOT 다중 선택 Set

    let isAmountFocused = {
        splpc: false,
        vat: false,
        fgcry_amount: false,
        won_amount: false,
    };

    function formatAmount(val) {
        if (val === null || val === undefined || val === "") return "0";
        const num = Number(val);
        if (isNaN(num)) return "0";
        return num.toLocaleString();
    }

    function handleAmountInput(field, e) {
        const clean = e.target.value.replace(/,/g, "").trim();
        if (clean === "" || isNaN(Number(clean))) {
            masterInfo[field] = 0;
        } else {
            masterInfo[field] = Number(clean);
        }
        masterInfo = masterInfo;
    }

    function getLotKey(lot) {
        return `${lot.lot_sn}_${lot.lot_no}_${lot.item_code}`;
    }

    // 💡 품목 그룹별로 LOT 순번(lot_sn)이 각각 1부터 증가하도록 재계산
    function recalculateLotSeqs(lots) {
        const groupCounts = {};
        return lots.map((lot) => {
            const key = `${lot.item_code}_${lot.rcvord_no || ""}_${lot.rcvord_sn || ""}`;
            if (groupCounts[key] === undefined) {
                groupCounts[key] = 1;
            } else {
                groupCounts[key] += 1;
            }
            return {
                ...lot,
                lot_sn: groupCounts[key]
            };
        });
    }

    function handleItemRowClick(item) {
        // 💡 이미 선택된 동일한 품목 클릭 시 선택 해제하지 않고 무조건 1개 선택 상태 고수
        if (selectedItem && 
            selectedItem.item_code === item.item_code && 
            selectedItem.rcvord_no === item.rcvord_no && 
            selectedItem.rcvord_sn === item.rcvord_sn
        ) {
            return;
        }
        selectedItem = item; // 신규 품목 선택 (해당 품목 LOT만 필터링 노출)
    }

    function handleLotClick(lot) {
        const key = getLotKey(lot);
        if (selectedLotKeys.has(key)) {
            selectedLotKeys.delete(key);
        } else {
            selectedLotKeys.add(key);
        }
        selectedLotKeys = selectedLotKeys; // Svelte 반응성 트리거
    }

    function deleteSelectedLot() {
        if (selectedLotKeys.size === 0) {
            toast.error("삭제할 행을 선택하세요.");
            return;
        }
        
        // 선택되지 않은 행들만 필터링 후 품목 그룹별 순번 재정의
        lotDetails = recalculateLotSeqs(
            lotDetails.filter((lot) => !selectedLotKeys.has(getLotKey(lot)))
        );
            
        selectedLotKeys.clear();
        selectedLotKeys = selectedLotKeys;
        toast.success("삭제되었습니다.");
    }

    async function handleFinalSave() {
        try {
            // 💡 필수값 검증 로직 추가 (주내역)
            if (!masterInfo.shipmnt_de) {
                toast.error("출하일자를 입력해 주세요.");
                return;
            }
            if (!masterInfo.bcnc_code) {
                toast.error("거래처 코드를 입력해 주세요.");
                return;
            }
            if (!masterInfo.shipmnt_se_code) {
                toast.error("출하형태를 선택해 주세요.");
                return;
            }

            // 💡 상세 내역 중 사용자가 선택(체크)한 항목만 필터링하여 전송
            const selectedDetails = details.filter(item => item.delchk === 'Y');

            if (selectedDetails.length === 0) {
                toast.error("저장할 상세 내역이 없습니다. 항목을 먼저 선택하세요.");
                return;
            }

            // 💡 LOT 내역 검증 로직 추가
            if (!lotDetails || lotDetails.length === 0) {
                toast.error("LOT 상세 내역이 하나도 없습니다. LOT을 추가해 주세요.");
                return;
            }
            
            const invalidLot = lotDetails.find(lot => !lot.qy || Number(lot.qy) <= 0);
            if (invalidLot) {
                toast.error(`LOT 수량이 0인 항목이 있습니다. (LOT 번호: ${invalidLot.lot_no || '알수없음'}) 수량을 올바르게 입력하세요.`);
                return;
            }

            // 💡 저장용 데이터 조립 (Master + 선택된 Detail + Lot)
            const saveData = {
                ...masterInfo,
                splpc: Number(masterInfo.splpc || 0),
                vat: Number(masterInfo.vat || 0),
                fgcry_amount: Number(masterInfo.fgcry_amount || 0),
                won_amount: Number(masterInfo.won_amount || 0),
                as_bplc_code: session_bplc_code, 
                detailsList: selectedDetails,
                lotsList: lotDetails
            };

            const response = await api.postJson("/shipment/saveShipment", saveData);

            if (response && response.code === 200) {
                toast.success(response.msg || "성공적으로 저장되었습니다.");
                // 저장 성공 후 콜백 호출 (화면 닫기, 리스트 새로고침 등)
                onSaveSuccess();
            } else {
                toast.error("저장에 실패했습니다.");
            }
        } catch (e) {
            console.error("Save Error:", e);
            toast.error("서버 통신 중 오류가 발생했습니다.");
        }
    }

    // 아코디언/확장 상태 제어 변수
    let expandedPane = 'none'; // 'none', 'upper', 'lower'

    function toggleUpper() {
        if (expandedPane === 'upper') {
            expandedPane = 'none';
        } else {
            expandedPane = 'upper';
        }
    }

    function toggleLower() {
        if (expandedPane === 'lower') {
            expandedPane = 'none';
        } else {
            expandedPane = 'lower';
        }
    }

    let isScanning = false;
    let tempLotInventory = []; // 백그라운드 사전 적재용 임시 재고 캐시
    let scannerRef; // BarcodeScannerModal 인스턴스 (스캔 판정 결과 전달용)

    // 💡 패널이 열리는 시점에 선택(체크)된 모든 품목의 LOT 재고 데이터를 백그라운드에서 사전 조회
    async function preloadLotStocks() {
        tempLotInventory = [];
        // details 중 delchk === "Y" 인 품목들 필터링
        const activeDetails = details.filter((d) => d.delchk === "Y");
        if (activeDetails.length === 0) return;

        try {
            const promises = activeDetails.map(async (item) => {
                const res = await api.get(
                    `/shipment/selectLotStockList?as_bplc_code=${session_bplc_code || "01"}&wrhous_code=${item.wrhous_code}&item_code=${item.item_code}`
                );
                if (res && res.data) {
                    // 수주 매칭용 키정보(rcvord_no, rcvord_sn)와 품목 정보 매핑
                    return res.data.map((lot) => ({
                        ...lot,
                        rcvord_no: item.rcvord_no,
                        rcvord_sn: item.rcvord_sn,
                        item_code: item.item_code,
                        item_nm: item.item_nm
                    }));
                }
                return [];
            });

            const results = await Promise.all(promises);
            tempLotInventory = results.flat();
            console.log("백그라운드 LOT 재고 사전 로드 완료:", tempLotInventory.length, "건");
        } catch (e) {
            console.error("백그라운드 재고 조회 중 에러 발생:", e);
        }
    }

    // 💡 바코드 스캔 성공 시 매칭 연동 및 1개씩 추가/누적 처리
    function handleBarcodeScan(e) {
        const barcode = e.detail;
        if (!barcode || barcode.trim() === "") return;

        // 1. [요구사항 6번] 품목이 선택되지 않은 경우 스캔 차단 및 경고 토스트 노출
        if (!selectedItem) {
            scannerRef?.reportResult(false, "스캔을 시작하려면 상단 [📋 품목 내역]에서 품목 라인을 먼저 선택해 주세요.");
            return;
        }

        // 2. 임시 로드된 재고 캐시에서 바코드(lot_no 또는 erp_lot_no)가 일치하는 재고 조회
        const matchedStock = tempLotInventory.find(
            (l) => l.lot_no === barcode || l.erp_lot_no === barcode
        );

        if (!matchedStock) {
            scannerRef?.reportResult(false, `스캔된 바코드(${barcode})와 일치하는 재고 LOT이 없습니다.`);
            return;
        }

        // 3. [요구사항 3번] 스캔된 LOT의 품목 정보가 현재 선택한 품목 정보와 일치하는지 검증
        if (
            matchedStock.item_code !== selectedItem.item_code ||
            matchedStock.rcvord_no !== selectedItem.rcvord_no ||
            matchedStock.rcvord_sn !== selectedItem.rcvord_sn
        ) {
            scannerRef?.reportResult(false, `스캔된 LOT은 선택한 품목[${selectedItem.item_nm}]의 재고가 아닙니다. 올바른 품목의 LOT을 스캔해 주세요.`);
            return;
        }

        const maxAllowedQty = Number(selectedItem.shipmnt_bnt || 0); // 선택된 품목의 출하수량 한도

        // 4. 현재 하단 LOT 상세 목록에 등록되어 있는 해당 품목의 총 누적 수량 계산
        const currentItemTotalQty = lotDetails
            .filter((lot) => lot.item_code === matchedStock.item_code)
            .reduce((sum, lot) => sum + Number(lot.qy || 0), 0);

        // 5. 수량 초과 검증 (현재 수량 + 1이 지정된 출하수량 한도를 초과하면 차단)
        if (currentItemTotalQty + 1 > maxAllowedQty) {
            scannerRef?.reportResult(false, `[${matchedStock.item_nm}] 품목은 지정된 출하수량(${maxAllowedQty}개)을 초과하여 등록할 수 없습니다. (현재 등록량: ${currentItemTotalQty}개)`);
            return;
        }

        // 6. 이미 등록되어 있는 lotDetails에 동일한 LOT 정보가 존재히는지 확인 (수주번호, 수주순번, 품목코드, LOT번호 매칭)
        const existingLotIndex = lotDetails.findIndex(
            (lot) =>
                lot.lot_no === matchedStock.lot_no &&
                lot.item_code === matchedStock.item_code &&
                lot.rcvord_no === matchedStock.rcvord_no &&
                lot.rcvord_sn === matchedStock.rcvord_sn
        );

        if (existingLotIndex > -1) {
            // 7. 존재 시 수량을 1 누적 증가 (단, 현재고량을 초과할 수 없음)
            const currentLot = lotDetails[existingLotIndex];
            const maxStock = Number(matchedStock.nrmlt_qy || 0);

            if (Number(currentLot.qy) >= maxStock) {
                scannerRef?.reportResult(false, `더 이상 추가할 수 없습니다. 현재고량(${maxStock}) 초과 (LOT: ${currentLot.lot_no})`);
                return;
            }

            lotDetails[existingLotIndex].qy = Number(currentLot.qy) + 1;
            lotDetails = [...lotDetails]; // Svelte 반응성 트리거
            scannerRef?.reportResult(true, `[${matchedStock.item_nm}] LOT 수량 1개 추가 (총 ${lotDetails[existingLotIndex].qy}개)`);
        } else {
            // 8. 미존재 시 신규 행으로 하단 LOT 목록에 수량 1개로 자동 추가
            const newLot = {
                lot_sn: 1, // recalculateLotSeqs에서 덮어씌워짐
                lot_no: matchedStock.lot_no,
                erp_lot_no: matchedStock.erp_lot_no,
                item_code: matchedStock.item_code,
                rcvord_no: matchedStock.rcvord_no,
                rcvord_sn: matchedStock.rcvord_sn,
                lot_se_code: matchedStock.lot_se_code || (matchedStock.erp_lot_no === matchedStock.lot_no ? "E" : "M"),
                qy: 1,
                wrhous_code: matchedStock.wrhous_code,
                pda_regist_at: "Y", // 무조건 Y 기본값
                rm: ""
            };

            lotDetails = recalculateLotSeqs([...lotDetails, newLot]);
            scannerRef?.reportResult(true, `[${matchedStock.item_nm}] 신규 LOT 등록 (LOT: ${newLot.lot_no})`);
        }
    }

    // 💡 패널이 열리고 품목 정보가 바인딩될 때 백그라운드 재고 조회 트리거
    $: if (isSidePanelOpen && details.length > 0) {
        preloadLotStocks();

        // 💡 최초 진입 시 상단 [📋 품목 내역]의 첫 번째 품목을 자동으로 활성화
        if (!selectedItem) {
            const activeDetails = details.filter((d) => d.delchk === "Y");
            if (activeDetails.length > 0) {
                selectedItem = activeDetails[0];
            }
        }
    }

    $: if (!isSidePanelOpen) {
        expandedPane = 'none';
        isScanning = false;
        tempLotInventory = []; // 패널 닫힐 때 캐시 비우기
        selectedItem = null; // 선택된 품목 상태 초기화
        selectedLotKeys.clear();
        selectedLotKeys = selectedLotKeys;
    }

    // 💡 선택된 품목에 매칭되는 LOT만 하단 상세 목록에 필터링하여 노출 (선택이 없으면 전체 노출)
    $: filteredLotDetails = selectedItem
        ? lotDetails.filter(
              (lot) =>
                  lot.item_code === selectedItem.item_code &&
                  lot.rcvord_no === selectedItem.rcvord_no &&
                  lot.rcvord_sn === selectedItem.rcvord_sn,
          )
        : lotDetails;
</script>

{#if isSidePanelOpen}
    <div
        class="side-panel full-page"
        transition:fly={{ x: 1200, duration: 400 }}
    >
        <header class="side-header">
            <button
                class="side-back-btn"
                on:click={() => (isSidePanelOpen = false)}
            >
                <span class="icon">⬅</span>
                상세내역으로
            </button>
            <h2>📦 주내역 및 LOT 통합 등록</h2>
            <button class="final-save-btn" on:click={handleFinalSave}>
                최종 저장
            </button>
        </header>

        <div class="side-body-split">
            <section class="split-pane" style="display: flex; flex-direction: column; overflow: hidden;">
                <div class="flex-between" style="margin-bottom: 15px; flex-shrink: 0;">
                    <div class="section-title" style="margin-bottom: 0;">
                        {isScanning ? "📷 바코드 스캐너" : "📋 주 내역 정보"}
                    </div>
                    {#if isScanning}
                        <button 
                            class="lot-del-btn" 
                            style="padding: 6px 14px; font-size: 0.75rem; border-radius: 6px; box-shadow: none;"
                            on:click={() => (isScanning = false)}
                        >
                            스캔 종료
                        </button>
                    {/if}
                </div>

                {#if isScanning}
                    <!-- 인라인 바코드 스캐너 렌더링 (스캔 결과 로그는 컴포넌트 내장 UI 사용) -->
                    <div style="position: relative; flex: 1; min-height: 420px; display: flex; flex-direction: column; overflow: hidden;">
                        <BarcodeScannerModal
                            bind:this={scannerRef}
                            isInline={true}
                            on:scan={handleBarcodeScan}
                            on:close={() => (isScanning = false)}
                        />
                    </div>
                {:else}
                    <!-- 기존 주 내역 정보 폼 -->
                    <div class="side-grid" style="overflow-y: auto; flex: 1; padding-right: 4px;">
                        <div class="f">
                            <label>출하번호</label>
                            <input
                                type="text"
                                bind:value={masterInfo.shipmnt_no}
                                readonly
                            />
                        </div>
                        <div class="f">
                            <label>출하형태</label>
                            <select bind:value={masterInfo.shipmnt_se_code}>
                                {#each shipmntTyList as item}
                                    <option value={item.refrn_code || ""}>
                                        {item.refrn_nm}
                                    </option>
                                {/each}
                            </select>
                        </div>
                        <div class="f">
                            <label>국내외구분</label>
                            <select bind:value={masterInfo.hbrd_se_code}>
                                {#each hbrdSeList as item}
                                    <option value={item.refrn_code || ""}>
                                        {item.refrn_nm}
                                    </option>
                                {/each}
                            </select>
                        </div>
                        <div class="f">
                            <label>출하등록구분</label>
                            <select bind:value={masterInfo.shipmnt_regist_se_code}>
                                {#each shipmntRegistSeList as item}
                                    <option value={item.refrn_code || ""}>
                                        {item.refrn_nm}
                                    </option>
                                {/each}
                            </select>
                        </div>
                        <div class="f">
                            <label>출하의뢰번호</label>
                            <input type="text" bind:value={masterInfo.reqest_no} />
                        </div>
                        <div class="f required">
                            <label>출하일자 <span class="req-star">*</span></label>
                            <input
                                type="date"
                                class="required-input"
                                bind:value={masterInfo.shipmnt_de}
                            />
                        </div>
                        <div class="f">
                            <label>거래처코드</label>
                            <input type="text" bind:value={masterInfo.bcnc_code} />
                        </div>
                        <div class="f">
                            <label>거래처명</label>
                            <input type="text" bind:value={masterInfo.bcnc_nm} />
                        </div>
                        <div class="f">
                            <label>부가세형태</label>
                            <select bind:value={masterInfo.vat_ty_code}>
                                {#each vatTyList as item}
                                    <option value={item.refrn_code || ""}>
                                        {item.refrn_nm}
                                    </option>
                                {/each}
                            </select>
                        </div>
                        <div class="f">
                            <label>부가세율</label>
                            <input type="number" bind:value={masterInfo.vat_rt} />
                        </div>
                        <div class="f">
                            <label>공급가</label>
                            <input
                                type="text"
                                inputmode="numeric"
                                class="text-right"
                                value={isAmountFocused.splpc
                                    ? (masterInfo.splpc ?? 0)
                                    : formatAmount(masterInfo.splpc)}
                                on:focus={(e) => {
                                    isAmountFocused.splpc = true;
                                    e.currentTarget.select();
                                }}
                                on:blur={() => (isAmountFocused.splpc = false)}
                                on:input={(e) => handleAmountInput("splpc", e)}
                            />
                        </div>
                        <div class="f">
                            <label>부가세</label>
                            <input
                                type="text"
                                inputmode="numeric"
                                class="text-right"
                                value={isAmountFocused.vat
                                    ? (masterInfo.vat ?? 0)
                                    : formatAmount(masterInfo.vat)}
                                on:focus={(e) => {
                                    isAmountFocused.vat = true;
                                    e.currentTarget.select();
                                }}
                                on:blur={() => (isAmountFocused.vat = false)}
                                on:input={(e) => handleAmountInput("vat", e)}
                            />
                        </div>
                        <div class="f">
                            <label>출고자사번</label>
                            <input
                                type="text"
                                bind:value={masterInfo.dlivy_empno}
                            />
                        </div>
                        <div class="f">
                            <label>출고자명</label>
                            <input
                                type="text"
                                bind:value={masterInfo.korean_nm}
                                readonly
                            />
                        </div>
                        <div class="f">
                            <label>통화코드</label>
                            <select bind:value={masterInfo.crncy_code}>
                                {#each crncyList as item}
                                    <option value={item.refrn_code || ""}>
                                        {item.refrn_nm}
                                    </option>
                                {/each}
                            </select>
                        </div>
                        <div class="f">
                            <label>환율</label>
                            <input type="number" bind:value={masterInfo.ehgt} />
                        </div>
                        <div class="f">
                            <label>외화금액</label>
                            <input
                                type="text"
                                inputmode="numeric"
                                class="text-right"
                                value={isAmountFocused.fgcry_amount
                                    ? (masterInfo.fgcry_amount ?? 0)
                                    : formatAmount(masterInfo.fgcry_amount)}
                                on:focus={(e) => {
                                    isAmountFocused.fgcry_amount = true;
                                    e.currentTarget.select();
                                }}
                                on:blur={() => (isAmountFocused.fgcry_amount = false)}
                                on:input={(e) =>
                                    handleAmountInput("fgcry_amount", e)}
                            />
                        </div>
                        <div class="f">
                            <label>원화금액</label>
                            <input
                                type="text"
                                inputmode="numeric"
                                class="text-right"
                                value={isAmountFocused.won_amount
                                    ? (masterInfo.won_amount ?? 0)
                                    : formatAmount(masterInfo.won_amount)}
                                on:focus={(e) => {
                                    isAmountFocused.won_amount = true;
                                    e.currentTarget.select();
                                }}
                                on:blur={() => (isAmountFocused.won_amount = false)}
                                on:input={(e) =>
                                    handleAmountInput("won_amount", e)}
                            />
                        </div>
                        <div class="f">
                            <label>상세정보번호</label>
                            <input
                                type="text"
                                bind:value={masterInfo.dvyfg_info_no}
                            />
                        </div>
                        <div class="f">
                            <label>우편번호</label>
                            <input type="text" bind:value={masterInfo.dvyfg_zip} />
                        </div>
                        <div class="f f-full">
                            <label>납품주소1</label>
                            <input
                                type="text"
                                bind:value={masterInfo.dvyfg_adres_1}
                            />
                        </div>
                        <div class="f f-full">
                            <label>납품주소2</label>
                            <input
                                type="text"
                                bind:value={masterInfo.dvyfg_adres_2}
                            />
                        </div>
                        <div class="f f-full">
                            <label>납품주소3</label>
                            <input
                                type="text"
                                bind:value={masterInfo.dvyfg_adres_3}
                            />
                        </div>
                        <div class="f">
                            <label>전화번호1</label>
                            <input
                                type="text"
                                bind:value={masterInfo.dvyfg_telno_1}
                            />
                        </div>
                        <div class="f">
                            <label>전화번호2</label>
                            <input
                                type="text"
                                bind:value={masterInfo.dvyfg_telno_2}
                            />
                        </div>
                        <div class="f">
                            <label>운송정보번호</label>
                            <input
                                type="text"
                                bind:value={masterInfo.trnsprt_info_no}
                            />
                        </div>
                        <div class="f">
                            <label>인수자명</label>
                            <input type="text" bind:value={masterInfo.acptr_nm} />
                        </div>
                        <div class="f">
                            <label>상태</label>
                            <select bind:value={masterInfo.sttus}>
                                {#each shipmntSttusList as item}
                                    <option value={item.refrn_code || ""}>
                                        {item.refrn_nm}
                                    </option>
                                {/each}
                            </select>
                        </div>
                        <div class="f f-full">
                            <label>비고</label>
                            <input type="text" bind:value={masterInfo.rm} />
                        </div>
                    </div>
                {/if}
            </section>

            <section class="split-pane lot-pane">
                <!-- 위쪽 영역: 선택된 상세 내역 정보 -->
                <div class="lot-sub-pane lot-upper-pane" class:expanded={expandedPane === 'upper'} class:collapsed={expandedPane === 'lower'}>
                    <div class="pane-header no-bg cursor-pointer" on:click={toggleUpper}>
                        <div class="section-title">📋 품목 내역 <span class="toggle-arrow">{expandedPane === 'upper' ? '▲' : '▼'}</span></div>
                    </div>
                    <div class="modal-table-scroll lot-detail-list-scroll">
                        <table class="mes-table item-summary-table">
                            <thead>
                                <tr>
                                    <th class="col-item-nm">품목명</th>
                                    <th class="col-item-qty num">출하수량</th>
                                    <th class="col-item-wrhous">창고명</th>
                                    <th class="col-item-stndrd">규격</th>
                                </tr>
                            </thead>
                            <tbody>
                                {#each details.filter((d) => d.delchk === "Y") as d}
                                    <tr
                                        class="cursor-pointer"
                                        class:item-row-selected={selectedItem &&
                                            selectedItem.item_code === d.item_code &&
                                            selectedItem.rcvord_no === d.rcvord_no &&
                                            selectedItem.rcvord_sn === d.rcvord_sn}
                                        on:click={() => handleItemRowClick(d)}
                                    >
                                        <td class="bold col-item-nm">{d.item_nm}</td>
                                        <td class="num bold col-item-qty" style="color: #2563eb;">
                                            {Number(d.shipmnt_bnt || 0).toLocaleString()}
                                        </td>
                                        <td class="col-item-wrhous">{d.wrhous_nm || ""}</td>
                                        <td class="col-item-stndrd">{d.stndrd || ""}</td>
                                    </tr>
                                {:else}
                                    <tr>
                                        <td colspan="4" class="center">
                                            선택된 상세 내역이 없습니다.
                                        </td>
                                    </tr>
                                {/each}
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- 경계선 -->
                <div class="pane-divider"></div>

                <!-- 아래쪽 영역: LOT 상세 내역 리스트 -->
                <div class="lot-sub-pane lot-lower-pane" class:expanded={expandedPane === 'lower'} class:collapsed={expandedPane === 'upper'}>
                    <div class="pane-header no-bg flex-between cursor-pointer" on:click={toggleLower}>
                        <div class="section-title">🔍 LOT 상세 내역 <span class="toggle-arrow">{expandedPane === 'lower' ? '▲' : '▼'}</span></div>
                        <div class="btn-group" on:click|stopPropagation>
                            <button 
                                class="lot-scan-btn" 
                                class:active-scan={isScanning}
                                on:click={() => (isScanning = !isScanning)}
                            >
                                🔍 SCAN
                            </button>
                            <button class="lot-add-btn" on:click={openLotPopup}>
                                <span class="icon">➕</span>
                                상세추가
                            </button>
                            <button class="lot-del-btn" on:click={deleteSelectedLot}>
                                <span class="icon">🗑️</span>
                                삭제
                            </button>
                        </div>
                    </div>
                    <div class="modal-table-scroll lot-list-scroll">
                        <table class="mes-table">
                            <thead>
                                <tr>
                                    <th>LOT순번</th>
                                    <th>LOT NO</th>
                                    <th>ERP LOT NO</th>
                                    <th>수량</th>
                                    <th>창고</th>
                                    <th>PDA등록여부</th>
                                    <th>비고</th>
                                </tr>
                            </thead>
                            <tbody>
                                {#each filteredLotDetails as lot, index}
                                    <tr
                                        class:selected={selectedLotKeys.has(getLotKey(lot))}
                                        on:click={() => handleLotClick(lot)}
                                    >
                                        <td class="center">{lot.lot_sn}</td>
                                        <td>{lot.lot_no || ""}</td>
                                        <td>{lot.erp_lot_no || ""}</td>
                                        <td class="num">{lot.qy || 0}</td>
                                        <td>{lot.wrhous_code || ""}</td>
                                        <td class="center">
                                            {lot.pda_regist_at === "N" ? "N" : "Y"}
                                        </td>
                                        <td>{lot.rm || ""}</td>
                                    </tr>
                                {/each}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </div>
    </div>
{/if}

<style>
    /* 💡 버튼 그룹 간격 */
    .btn-group {
        display: flex;
        gap: 8px;
    }

    /* 💡 LOT 삭제 버튼 */
    .lot-del-btn {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        color: white;
        border: none;
        padding: 8px 18px;
        border-radius: 8px;
        font-weight: 800;
        font-size: 0.8rem;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
        box-shadow: 0 4px 6px -1px rgba(239, 68, 68, 0.3);
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .lot-del-btn:hover {
        transform: translateY(-1px);
        box-shadow: 0 10px 15px -3px rgba(239, 68, 68, 0.4);
        background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
    }

    /* 💡 선택된 행 스타일 */
    .mes-table tbody tr.selected {
        background-color: #e2e8f0 !important;
        border-left: 4px solid #3b82f6;
    }
    /* 💡 품목 내역의 선택된 품목 행 스타일 (초록색 포인트로 가시성 확보) */
    .mes-table tbody tr.item-row-selected {
        background-color: #f0fdf4 !important;
        border-left: 4px solid #10b981;
    }
    .side-back-btn {
        background: rgba(255, 255, 255, 0.1);
        color: white;
        border: 1.5px solid rgba(255, 255, 255, 0.4);
        padding: 8px 18px;
        border-radius: 20px; /* 알약 형태 */
        font-weight: 800;
        font-size: 0.8rem;
        cursor: pointer;
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .side-back-btn:hover {
        background: white;
        color: #1e293b;
        transform: translateX(-3px); /* 뒤로가기 느낌 강조 */
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }

    .side-back-btn .icon {
        font-size: 1rem;
    }

    /* 💡 최종 저장 버튼 디자인 강화 */
    .final-save-btn {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        border: none;
        padding: 10px 28px;
        border-radius: 8px;
        font-weight: 900;
        font-size: 0.95rem;
        cursor: pointer;
        transition:
            transform 0.2s,
            box-shadow 0.2s;
        box-shadow: 0 4px 6px rgba(16, 185, 129, 0.2);
    }

    .final-save-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 12px rgba(16, 185, 129, 0.4);
    }

    /* --- 기존 스타일 보존 --- */
    .side-panel.full-page {
        position: fixed;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background: #f8fafc;
        z-index: 2001;
        display: flex;
        flex-direction: column;
    }
    .side-header {
        background: #1e293b;
        color: white;
        padding: 15px 25px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .side-body-split {
        flex: 1;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1px;
        background: #cbd5e0;
        overflow: hidden;
    }

    .split-pane {
        background: white;
        padding: 10px;
        overflow-y: auto;
    }
    .side-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
    }
    .f label {
        display: block;
        font-size: 0.7rem;
        font-weight: 800;
        color: #64748b;
        margin-bottom: 4px;
    }
    .f.required label {
        color: #1e293b;
    }
    .req-star {
        color: #ef4444;
        font-weight: 900;
        margin-left: 2px;
    }
    .required-input {
        background-color: #ffedd5 !important; /* 살구색 (Peach/Apricot) */
        border: 1.5px solid #fdba74 !important;
        font-weight: 700;
        color: #1e293b;
    }
    .required-input:focus {
        border-color: #f97316 !important;
        box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.25) !important;
        outline: none;
    }
    .f input,
    .f select {
        width: 100%;
        height: 35px;
        border: 1px solid #cbd5e1;
        border-radius: 4px;
        padding: 0 10px;
        font-size: 0.85rem;
    }
    .text-right {
        text-align: right !important;
    }
    .f-full {
        grid-column: span 2;
    }
    .section-title {
        font-size: 1rem;
        font-weight: 800;
        color: #1e293b;
        border-left: 4px solid #3b82f6;
        padding-left: 10px;
        margin-bottom: 8px;
    }
    .lot-add-btn {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        color: white;
        border: none;
        padding: 8px 18px;
        border-radius: 8px;
        font-weight: 800;
        font-size: 0.8rem;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
        box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.3);
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .lot-add-btn:hover {
        transform: translateY(-1px);
        box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.4);
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    }
    .lot-add-btn .icon {
        font-size: 0.9rem;
        font-weight: 900;
        color: white;
    }
    .flex-between {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
    .mes-table {
        width: 100%;
        border-collapse: collapse;
    }
    .mes-table th {
        position: sticky;
        top: 0;
        z-index: 5;
        background: #f8fafc;
        padding: 6px 10px;
        border-bottom: 2px solid #e2e8f0;
        font-size: 0.8rem;
        text-align: left;
    }
    .mes-table td {
        padding: 6px 10px;
        border-bottom: 1px solid #f1f5f9;
        font-size: 0.85rem;
    }
    .center {
        text-align: center;
    }
    .num {
        text-align: right;
    }
    .modal-table-scroll {
        flex: 1;
        overflow: auto;
        border: 1px solid #e2e8f0;
        border-radius: 4px;
        margin-top: 4px;
    }
    .no-bg {
        background: transparent !important;
        border-bottom: none !important;
        padding: 0 0 4px 0;
    }
    .lot-pane {
        display: flex;
        flex-direction: column;
        height: 100%;
        gap: 6px;
    }
    .cursor-pointer {
        cursor: pointer;
        user-select: none;
    }
    .toggle-arrow {
        font-size: 0.7rem;
        color: #94a3b8;
        margin-left: 6px;
    }
    .lot-sub-pane {
        display: flex;
        flex-direction: column;
        min-height: 0;
        transition: all 0.25s ease-in-out;
    }
    /* 기본 상태: 반반 분할 */
    .lot-sub-pane:not(.expanded):not(.collapsed) {
        flex: 1;
    }
    /* 확장 상태 */
    .lot-sub-pane.expanded {
        flex: 1;
        height: 100%;
    }
    /* 축소 상태: 타이틀 헤더만 남김 */
    .lot-sub-pane.collapsed {
        flex: 0 0 auto;
    }
    .lot-sub-pane.collapsed .modal-table-scroll {
        display: none;
    }

    .lot-scan-btn {
        background: #10b981;
        color: white;
        border: none;
        padding: 8px 18px;
        border-radius: 8px;
        font-weight: 800;
        font-size: 0.8rem;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
        box-shadow: 0 4px 6px -1px rgba(16, 185, 129, 0.2);
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .lot-scan-btn:hover {
        background: #059669;
        transform: translateY(-1px);
        box-shadow: 0 6px 12px rgba(16, 185, 129, 0.3);
    }
    .lot-scan-btn.active-scan {
        background: #ef4444;
        box-shadow: 0 4px 6px -1px rgba(239, 68, 68, 0.2);
    }
    .lot-scan-btn.active-scan:hover {
        background: #dc2626;
    }

    .pane-divider {
        height: 1px;
        background: #cbd5e1;
        margin: 2px 0;
    }

    .item-summary-table {
        min-width: 650px !important;
        width: 100%;
        table-layout: auto;
        white-space: nowrap;
    }
    .item-summary-table th,
    .item-summary-table td {
        white-space: nowrap !important;
    }
    .col-item-nm {
        min-width: 220px;
        white-space: nowrap;
    }
    .col-item-qty {
        width: 65px;
        min-width: 60px;
        white-space: nowrap;
    }
    .col-item-wrhous {
        width: 80px;
        min-width: 75px;
        white-space: nowrap;
    }
    .col-item-stndrd {
        min-width: 200px;
        white-space: nowrap;
    }
    .lot-detail-list-scroll {
        flex: 1;
        overflow: auto;
        border: 1px solid #cbd5e1;
        border-radius: 6px;
    }
    .lot-list-scroll {
        flex: 1;
        overflow: auto;
        border: 1px solid #cbd5e1;
        border-radius: 6px;
    }
</style>
